export const PRICE_INDRA_TETHERED = 1049;
export const PRICE_INDRA_UNTETHERED = 999;
export const PRICE_HYPERVOLT_5M = 999;
export const PRICE_HYPERVOLT_7_5M = 1099;
export const PRICE_HYPERVOLT_10M = 1119;
export const PRICE_ANDERSEN_QUARTZ_SOCKET = 1199;
export const PRICE_ANDERSEN_QUARTZ_5_5M = 1249;
export const PRICE_ANDERSEN_QUARTZ_8_5M = 1299;
export const PRICE_ANDERSEN_QUARTZ_SOCKET_PREMIUM = 1349;
export const PRICE_ANDERSEN_QUARTZ_5_5M_PREMIUM = 1399;
export const PRICE_ANDERSEN_QUARTZ_8_5M_PREMIUM = 1449;
export const PRICE_ANDERSEN_A3_BASE = 1499;
export const PRICE_ANDERSEN_A3_PREMIUM = 1699;
export const PRICE_ANDERSEN_A2_BASE = 1799;
export const PRICE_ANDERSEN_A2_PREMIUM = 1999;
export const PRICE_ZAPPI_21_SOCKET = 999;
export const PRICE_ZAPPI_21_TETHERED = 1049;
